module.exports = __webpack_public_path__ + "assets/1ff68c72ec48a0a8d3f19caf309f181e.mp3";